// extracted by mini-css-extract-plugin
export default {"otherCourses":"OtherCourses_otherCourses__bxBpf","sectionHeading":"OtherCourses_sectionHeading__w9jrH"};